<template>
    <span class="tooltip-right" data-tooltip="Create Trip Ticket"  @click="submitTicket">
        <i class="fa fa-sticky-note"></i>
    </span>  
</template>

<script>
    export default {
        props: {
            trip: null
        },
        created () {
            this.newValue = this.trip
        },
        methods: {
            submitTicket () {
                console.log("CLICK CREATE TICKET SUBMIT");
                this.$eventHub.$emit('createTripTicket', {
                    id: this.trip.id
                })
            }
        },
    }
</script>
